import ButtonAction from "@visa/vds/button-action";
import ButtonLabel from "@visa/vds/button-label";
import ButtonMenu from "@visa/vds/button-menu";
import Icon from "@visa/vds/icon";
import Listbox from "@visa/vds/listbox";
import Navmenu from "@visa/vds/navmenu";
import React from "react";
import "./ActionMenu.css";
import ActionMenuItem from "./ActionMenuItem";

const ActionMenu = (props) => {
  return (
    <>
      <Navmenu
        id={"action-menu-" + props.dataId}
        className="actionMenu"
        placement="bottom-end"
        menu={
          <Listbox name="listbox-action-menu">
            <ActionMenuItem
              dataId={props.dataId}
              buttonText="Edit"
              iconName="edit"
              clickHandler={props.handleClickEdit}
            ></ActionMenuItem>
            <ActionMenuItem
              dataId={props.dataId}
              dataName={props.dataName}
              buttonText="Delete"
              iconName="delete"
              clickHandler={props.handleClickDelete}
            ></ActionMenuItem>
          </Listbox>
        }
      >
        <ButtonMenu flippable colorScheme="secondary">
          <ButtonLabel>Action</ButtonLabel>
          <ButtonAction>
            <Icon name="arrow-expand" resolution="tiny" />
          </ButtonAction>
        </ButtonMenu>
      </Navmenu>
    </>
  );
};

export default ActionMenu;
